import { render, staticRenderFns } from "./PageSubtitle.vue?vue&type=template&id=0f4e4e94&scoped=true&"
import script from "./PageSubtitle.vue?vue&type=script&lang=js&"
export * from "./PageSubtitle.vue?vue&type=script&lang=js&"
import style0 from "./PageSubtitle.vue?vue&type=style&index=0&id=0f4e4e94&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f4e4e94",
  null
  
)

export default component.exports